import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { changeSelectedTab } from "components/modal/portfolio-creation-edit/portfolio-edition/insPortfolioEditionContentStepTwo";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsPortfolioEditionStepTwoDialogAction = () => {
    const dispatch = useDispatch();
    const selectedTabUid = useSelector((state) => state.portfolioCreation.selectedTab);
    return useMemo(() => React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { key: "main-delete-button", label: language.en.common.ok, type: AuxButtonTypeEnum.PRIMARY, onClick: () => {
                changeSelectedTab(selectedTabUid, dispatch);
                dispatch(closeDialog());
            } }),
        React.createElement(CloseDialogButton, null)), [dispatch, selectedTabUid]);
};
